
import { LeftProps } from "../../../assets/icons";
import { Utils } from "../../../utils/Utils";
import { paymentTypeInitial } from "./paymentHelpers";

export default function PaymentSummaryCard({
	payment,
	showChevron = false,
	className = "",
}) {
	const priceToman = Utils.convertTomanComma(payment.charge);

	return (
		<div
			className={[
				"relative overflow-hidden rounded-[14px] border border-darkBlue/10 bg-white",
				"shadow-[0_4px_16px_rgba(39,106,166,0.08)]",
				className,
			].join(" ")}
		>
			<div
				className="absolute inset-y-0 right-0 w-[3px] bg-gradient-to-b from-cta via-[#FF825E] to-darkBlue"
				aria-hidden
			/>

			<div className="flex flex-col gap-3 p-4 pr-5 sm:flex-row sm:items-center sm:gap-4">
				<div className="flex min-w-0 flex-1 items-center gap-3">
					<div
						className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[12px] bg-gradient-to-br from-lightCta to-white ring-1 ring-darkBlue/10 font-Vazir-700 text-[15px] text-darkBlue"
						aria-hidden
					>
						{paymentTypeInitial(payment.fa_product_type)}
					</div>
					<div className="min-w-0 flex-1 text-right">
						<p className="font-Vazir-600 text-[15px] text-darkBlue">
							{payment.fa_product_type}
						</p>
						<p
							className="mt-0.5 font-Vazir-400 text-[13px] text-darkBlue/50"
							dir="ltr"
						>
							{payment.j_create_datetime}
						</p>
					</div>
				</div>

				<div className="flex items-center justify-between gap-3 sm:justify-end sm:shrink-0">
					<div className="text-right sm:text-left">
						<p className="font-Vazir-700 text-[17px] text-cta leading-tight">
							{priceToman}
						</p>
						<p className="font-Vazir-400 text-[12px] text-darkBlue/55">تومان</p>
					</div>
					{showChevron && (
						<span
							className="flex h-9 w-9 items-center justify-center rounded-full bg-lightCta text-darkBlue/70 rotate-180"
							aria-hidden
						>
							<LeftProps stroke="#276AA6" height="12px" width="7px" />
						</span>
					)}
				</div>
			</div>
		</div>
	);
}
